// Russian/English display labels for DB values that are stored as English slugs/strings.

const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

const CATEGORY_RU = {
  culture_archaeology: "Культура и археология",
  culture_history: "Культура и история",
  culture_nature: "Культура и природа",
  expedition: "Экспедиция",
  geology: "Геология",
  geology_road: "Геология и дорога",
  lake_nature: "Озёра и природа",
  mountain_road: "Горная дорога",
  mountains: "Горы",
  nature: "Природа",
  nature_active: "Природа и актив",
  panorama: "Панорама",
  photography: "Фотография",
  road_history: "Дорога и история",
  road_nature: "Дорога и природа",
  seasonal_nature: "Сезонная природа",
  seasonal_photography: "Сезонная фотография",
  trekking: "Треккинг",
  winter_panorama: "Зимняя панорама",
  overview_ethnography: "Обзорные и этнография",
  chuysky_geology: "Чуйский тракт и геология",
  chemal_nature_parks: "Чемал, озёра и парки",
  trekking_extreme: "Треккинг и экстрим",
  winter_resorts: "Зима и курорты",
};

const DIFF = {
  easy: { ru: "Легко", en: "Easy" },
  easy_to_moderate: { ru: "Легко–средне", en: "Easy–moderate" },
  moderate: { ru: "Средне", en: "Moderate" },
  moderate_to_hard: { ru: "Средне–сложно", en: "Moderate–hard" },
  active: { ru: "Активно", en: "Active" },
  hard: { ru: "Сложно", en: "Hard" },
  expedition: { ru: "Экспедиция", en: "Expedition" },
};

const DISTRICT_RU = {
  Chemalsky: "Чемальский район",
  "Gorno-Altaysk": "Горно-Алтайск",
  Kosh_Agachsky: "Кош-Агачский район",
  "Kosh-Agachsky": "Кош-Агачский район",
  Mayminsky: "Майминский район",
  Ongudaysky: "Онгудайский район",
  Turochaksky: "Турочакский район",
  "Turochaksky/Ulagansky": "Турочакский / Улаганский р-н",
  Ulagansky: "Улаганский район",
  "Ust-Koksinsky": "Усть-Коксинский район",
  "Ongudaysky/Kosh-Agachsky": "Онгудайский / Кош-Агачский район",
  "Sovetsky (Altai Krai)": "Советский район (Алтайский край)",
  "Belokurikha (Altai Krai)": "Белокуриха (Алтайский край)",
};

const DURATION_RU = {
  "3–4 h": "3–4 ч",
  "4–6 h": "4–6 ч",
  "4–7 h": "4–7 ч",
  "5–8 h": "5–8 ч",
  "6–8 h": "6–8 ч",
  "6–9 h": "6–9 ч",
  "6–10 h from Aktash/Ulagan": "6–10 ч от Акташа/Улагана",
  "10–13 h": "10–13 ч",
  "10–14 h": "10–14 ч",
  "12–15 h / best as 2 days": "12–15 ч / лучше за 2 дня",
  "13–16 h / best as 2 days": "13–16 ч / лучше за 2 дня",
  "1–2 days": "1–2 дня",
  "2 days recommended": "рекомендуется 2 дня",
  "3–5+ days": "3–5+ дней",
  "3–6 days": "3–6 дней",
  "half/full day from valley base": "полдня / день от базы в долине",
};

const TRANSPORT_RU = {
  "4x4_partner": "внедорожник (партнёр)",
  car: "автомобиль",
  car_optional: "автомобиль (по желанию)",
  expedition_4x4: "экспедиционный внедорожник",
  high_clearance_vehicle: "внедорожник",
  local_transfer: "местный трансфер",
  partner_boat: "катер (партнёр)",
  walking: "пешком",
};

export const catLabel = (c, lang) => {
  if (!c) return "";
  if (lang === "ru") return CATEGORY_RU[c] || c.split("_").map(cap).join(" ");
  return c.split("_").map(cap).join(" ");
};

export const diffLabel = (d, lang) => {
  if (!d) return "";
  const m = DIFF[d];
  if (m) return m[lang];
  return d.split("_").map(cap).join(" ");
};

export const distLabel = (d, lang) => {
  if (!d) return "";
  if (lang === "ru") return DISTRICT_RU[d] || d;
  return d;
};

export const durLabel = (d, lang) => {
  if (!d) return "";
  if (lang === "ru") return DURATION_RU[d] || d;
  return d;
};

export const transportLabel = (list, lang) => {
  if (!Array.isArray(list)) return "";
  return list
    .map((t) => (lang === "ru" ? TRANSPORT_RU[t] || t.replace(/_/g, " ") : t.replace(/_/g, " ")))
    .join(", ");
};
